module.exports = __webpack_public_path__ + "static/media/form.a1ba9ab0.svg";